import React, { useState } from 'react'
import { Button, Checkbox, Dialog, DialogContent, DialogTitle, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { deleteMaterialGroup, getOneGroup } from '@auteco/services/snopServices'
import { verifyNullValue } from '@auteco/utils/verifyNullValue'
import { initialAlert } from '@auteco/constants'
import { Alert } from '@auteco/components/snopComponents/Alert'
import useStyles from './styles'


const DialogConsultGroup = ({ groups, open, onClose }) => {
    const [groupId, setGroupId] = useState('')
    const [materials, setMaterials] = useState([])
    const [alertInfo, setAlertInfo] = useState(initialAlert)
    const [selectedMaterials, setSelectedMaterials] = useState([])

    const classes = useStyles()

    const handleClose = () => {
        setMaterials([])
        setGroupId('')
        onClose()
        setSelectedMaterials([])
    }

    const onConsultGroup = async ({ id }) => {
        setGroupId(id)
        if (id !== '') {
            const { materiales } = await getOneGroup({ id })
            if (materiales) {
                setMaterials(materiales)
            } else {
                setMaterials([])
            }
        } else {
            setMaterials([])
        }
    }

    const onSelectMaterial = ({ isChecked, material }) => {
        if (isChecked) {
            setSelectedMaterials(prevMaterials => ([...prevMaterials, material]))
        } else {
            setSelectedMaterials(prevMaterials => (prevMaterials.filter(item => item.material !== material.material)))
        }
    }

    const onCloseAlert = () => {
        setAlertInfo(initialAlert)
    }


    const onDeleteMaterials = async () => {
        const codes = selectedMaterials.map(material => material.material)
        const body = {
            grupo_id: groupId,
            material: codes
        }
        const { success } = await deleteMaterialGroup({ params: body })
        if (success === 1) {
            onConsultGroup({ id: groupId })
        }
        setAlertInfo(initialAlert)
        setSelectedMaterials([])
    }

    const deleteMaterials = () => {
        setAlertInfo({ title: '¡Espera!', content: `Estás a punto de eliminar ${selectedMaterials.map(item => item.texto)} del grupo, ¿deseas continuar?`, textBtn1: 'Cerrar', textBtn2: 'Continuar', open: true, onClose: onCloseAlert, funcBtn: () => onDeleteMaterials() })
    }
    return (
        <>
            <Alert
                title={alertInfo.title}
                content={alertInfo.content}
                textBtn1={alertInfo.textBtn1}
                textBtn2={alertInfo.textBtn2}
                funcBtn={alertInfo.funcBtn}
                open={alertInfo.open}
                onClose={onCloseAlert}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Consultar grupo</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    {groupId === '' && <Typography className={classes.advice}>Selecciona el grupo a consultar</Typography>}
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={groups}
                        getOptionLabel={(option) => option.nombre}
                        onChange={(e, newValue) => onConsultGroup({ id: verifyNullValue({ value: newValue, param: 'id' }) })}
                        renderInput={(params) => <TextField {...params} label="Grupos" variant='outlined' />}
                    />
                    {groupId !== '' && materials.length > 0 ?
                        <>
                            <Typography className={classes.materialsTitle}>Materiales del grupo ({materials.length})</Typography>
                            <div className={classes.materialsContainer}>
                                {materials.map(material =>
                                    <div className={classes.material}>
                                        <Checkbox
                                            color='primary'
                                            checked={selectedMaterials.some(item => item.material === material.material)}
                                            onChange={(e, isChecked) => onSelectMaterial({ isChecked, material })}
                                        />
                                        <p className={classes.materialTxt}>{material.texto}</p>
                                    </div>

                                )}
                            </div>
                        </>
                        :
                        groupId !== '' && <Typography>No hay materiales en este grupo</Typography>
                    }
                </DialogContent>
                <div className={classes.btnsContainer}>
                    {selectedMaterials.length > 0 && <Button variant='contained' color='primary' className={classes.deleteBtn} onClick={deleteMaterials}>Eliminar</Button>}
                    <Button className={classes.closeBtn} variant='contained' onClick={handleClose}>Volver</Button>
                </div>
            </Dialog >
        </>
    )
}

export { DialogConsultGroup }